import type { WebModule } from '../registry';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';

export { AuthProvider, useAuth, useUser } from './context';
export type { AuthContextValue, AuthStatus } from './context';
export { RequireAuth } from './components/RequireAuth';
export { ProfileCard } from './components/ProfileCard';
export { ColorPicker } from './components/ColorPicker';
export { AvatarPicker } from './components/AvatarPicker';
export { LoginPage } from './pages/LoginPage';
export { RegisterPage } from './pages/RegisterPage';
export * from './api';

/**
 * Auth module (client side, ROADMAP §3 WS-2). No Yjs doc and no nav entry — signing in
 * isn't a destination the household nav links to. Routes are registered here per the
 * module contract; WS-3 maps them onto whichever router it picks.
 */
export const authWebModule: WebModule = {
  id: 'auth',
  routes: [
    { path: '/login', component: LoginPage },
    { path: '/invite/:token', component: RegisterPage },
  ],
};
